import * as Sentry from "@sentry/react";

function initSentry() {
Sentry.init({
  dsn: "https://b80f3220e7e0c5c5baf86bc7f12da8eb@o4509388177080320.ingest.us.sentry.io/4509388177997824",
  sendDefaultPii: true
});
}

export  {initSentry};